import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  SeatQuota = 'SeatQuota',
}

export const useGetSeatQuotaQuery = () => {
  const { getSeatQuota } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.SeatQuota],
    queryFn: getSeatQuota,
  });
};
